import {combineReducers} from "redux";
import main from "./main";
import projects from "./projects";
import cache from "./cache";
import auth from "./auth";

const createReducer = (asyncReducers?: any) =>
	combineReducers({
		auth,
		cache,
        main,
		projects,
		...asyncReducers
	});

export default createReducer;